import { isExperimentLoaded } from "@epsilon-org/framework/epsilonLab";

export const furnitureTakeBack = () => isExperimentLoaded(225);
